import React from 'react';
import { useReporter } from '../../reporter';
import { useExperiment, BACKGROUND_COLOR_EXPERIMENT } from '..';

export const BackgroundColorTestComponent = () => {
  const { value } = useExperiment(BACKGROUND_COLOR_EXPERIMENT, 'green');
  const reporter = useReporter();
  return (
    <>
      <div
        style={{
          height: '500px',
          width: '500px',
          textAlign: 'center',
          backgroundColor: value,
        }}
      ></div>
      <p>Color is {value}</p>
      <button
        onClick={() => reporter.tag({ type: 'Flagship Test Button Click' })}
      >
        Background Color Test Experiment Click
      </button>
    </>
  );
};

BackgroundColorTestComponent.displayName = 'BackgroundColorTestComponent';
